<app-admin-header *ngIf="hasAccess(['ADMIN'])"></app-admin-header>
<app-mda-header *ngIf="hasAccess(['MDA'])"></app-mda-header>

<div class="container" style="min-height: 62vh"><br><br>
    <div class="bg-white">
        <div class="reports-heading mb-3 mt-2 px-3">
            <div class="ms-1 top-bar-div">
                <div class="mt-3">
                    <h6>Check Payment Status</h6>
                </div>
            </div>
        </div>
        <div class="search-parameters">

            <form class="search-form" [formGroup]="searchForm">
                <div class="row mt-4 mb-3">
                    <div class="col-md-4 mt-2">
                        <label>Payment Scheme</label>
                        <select name="" class="form-control small-option-font" formControlName="scheme">
                            <option value="">Select</option>
                            <option value="WEB">INTERSWITCH WEB</option>
                            <option value="REMITA">REMITA</option>
                            <option value="Anigr">INTERSWITCH ANIGR</option>
                            <option value="Pos">INTERSWITCH POS</option>
                            <option value="IVAS">INTERSWITCH IVAS</option>
                        </select>
                    </div>

                    <div class="col-md-4 mt-2"  *ngIf="searchForm.get('scheme').value=='Anigr' || searchForm.get('scheme').value=='IVAS' || searchForm.get('scheme').value=='Pos'">
                        <label>Search By</label>
                        <select name="" class="form-control small-option-font" formControlName="searchBy">
                            <option value="">Select</option>
                            <option value="payment_reference">Payment Reference</option>
                            <option value="customer_number" *ngIf="searchForm.get('scheme').value=='Anigr'">ASIN</option>
                            <option value="customer_number" *ngIf="searchForm.get('scheme').value=='Pos'">ASIN/Reference</option>
                            <option value="customer_number" *ngIf="searchForm.get('scheme').value=='IVAS'">IVAS Reference</option>
                        </select>
                    </div>

                    <div class="col-md-4 mt-2"  *ngIf="searchForm.get('searchBy').value=='customer_number'">
                        <label>Start Date</label>
                        <input
                                type="date"
                                class="form-control small-option-font"
                                formControlName="startDate"
                        />
                    </div>

                    <div class="col-md-4 mt-2"  *ngIf="searchForm.get('searchBy').value=='customer_number'">
                        <label>Start Date</label>
                        <input
                                type="date"
                                class="form-control small-option-font"
                                formControlName="endDate"
                        />
                    </div>

                    <div class="col-md-4 mt-2">
                        <label>Search Value</label>
                        <input
                                type="text"
                                class="form-control small-option-font"
                                formControlName="paymentRef"
                                placeholder="Payment Reference/ASIN/Reference Number"
                        />
                    </div>
                    <div class="col-md-4 mt-2 me-2">
                        <button
                                class="btn btn-sm search-button small-option-font pointer"
                                (click)="search()"
                                type="submit" [disabled]="searchForm.invalid">
                            <b *ngIf="!isLoading">Search</b>
                            <b *ngIf="isLoading"  class="spinner-border text-white"></b>
                        </button>
                    </div>
                    <div class="col-md-3 mt-2 ">
                        <button
                                class="btn btn-sm reset-button small-option-font"
                                (click)="resetForm()"
                                type="submit">
                            Reset
                        </button>
                    </div>
                </div>
            </form>

        </div>
        <div *ngIf="paymentDetails.length > 0">
            <table class="table table-responsive-sm">
                <thead class="assess-table-head">
                <tr>
                    <th class="alert alert-success text-center" colspan="5">The below payment has been saved and reconciled</th>
                </tr>
                    <tr>
                        <th>SNo.</th>
                        <th>Payment Reference</th>
                        <th>Payment Date</th>
                        <th>Payment Amount</th>
                        <th>Taxpayer Name</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let pay of paymentDetails; let i = index">
                        <td>{{i + 1}}</td>
                        <td>{{pay.payRef || pay.paymentRefNum}}</td>
                        <td>{{pay.paymentDate || pay.paymentLogDate | date}}</td>
                        <td>{{pay.amount || pay.paylogDetailsAmount/100 | currency:'NGN':'symbol-narrow':'2.2-2' }}</td>
                        <td>{{pay.payerName || pay.custName}}</td>

                    </tr>
                </tbody>
            </table>
        </div>
        <div *ngIf="remittaDetails && paymentDetails.length == null" class="text-center">
            <table class="table table-responsive-sm">
                <thead class="assess-table-head">
                <tr>
                    <th class="alert alert-success text-center" colspan="5">The below payment has been saved and reconciled</th>
                </tr>
                    <tr>
                        <th>SNo.</th>
                        <th>Payment Reference</th>
                        <th>Payment Date</th>
                        <th>Payment Amount</th>
                        <th>Taxpayer Name</th>
                    </tr>
                </thead>
                <tbody>
                    <tr >
                        <td>{{1}}</td>
                        <td>{{remittaDetails.rrr || remittaDetails.rrr}}</td>
                        <td>{{remittaDetails.paymentDate || remittaDetails.paymentLogDate | date}}</td>
                        <td>{{remittaDetails.amount || remittaDetails.paylogDetailsAmount/100 | currency:'NGN':'symbol-narrow':'2.2-2' }}</td>
                        <td>{{remittaDetails.taxPayerName || remittaDetails.taxPayerName}}</td>

                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div style="position: sticky !important;bottom: 0 !important;">
    <app-footer *ngIf="hasAccess(['ADMIN'])" class="m-hidden"></app-footer>
    <app-mda-footer *ngIf="hasAccess(['MDA'])" class="m-hidden"></app-mda-footer>

</div>
